import get from 'lodash/get';
import {
  fieldTypeToQueryTypeMap,
  queryConfigMap,
  // QueryConfig,
  // QueryType,
  // Field,
} from './SingleSelectDropdown.constants';

/**
 * Gets the gql query from the given query type
 */
export const getGQLQuery = (queryType /*: QueryType */) => queryConfigMap[queryType]?.gqlQuery;

/**
 * Gets the single gql query from the given query type
 */
export const getSingleGQLQuery = (queryType /*: QueryType */) =>
  queryConfigMap[queryType]?.singleQuery;

/**
 * Gets the query type for a given field
 */
export const getFieldQueryType = (field /* : Field */) /*: QueryType */ =>
  fieldTypeToQueryTypeMap[field];

/**
 * Gets the query configuration - which contains helpful info - for a given
 * field
 */
export const getFieldQueryConfig = (field /* : Field */) /*: QueryConfig */ =>
  queryConfigMap[getFieldQueryType(field)];

/**
 * Returns whether the gql query for a field is paginated or not
 */
export const getHasPagination = (field /* : Field */) => !!getFieldQueryConfig(field)?.isPaginated;

/**
 * Gets the correct results path from returned data object
 */
export const getResultsFromData = (data = {}, field /*: Field */) =>
  get(data, getFieldQueryConfig(field)?.resultsPath) || [];
